// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"998acf36","511":"275f6edf","562":"98494997","905":"b23f1d64"}[chunkId] + ".chunk.css";
};